import { createContext, useContext } from "react";
import { TamaguiProvider } from "@tamagui/core";
import { PortalProvider } from "@tamagui/portal";
import config from "./tamagui.config";
import { jsx } from "react/jsx-runtime";
const defaultAnalyticsContext = {
    useObservability: () => ({
      trackJourneyEvent: (_categoryName, _eventName, _eventData, _contextualData) => {}
    })
  },
  AnalyticsContext = createContext(defaultAnalyticsContext),
  useAnalyticsContext = () => useContext(AnalyticsContext);
function BricksProvider({
  children,
  useObservability,
  ...rest
}) {
  return useObservability = useObservability ?? defaultAnalyticsContext.useObservability, /* @__PURE__ */jsx(AnalyticsContext.Provider, {
    value: {
      useObservability
    },
    children: /* @__PURE__ */jsx(TamaguiProvider, {
      config,
      defaultTheme: "light",
      ...rest,
      children: /* @__PURE__ */jsx(PortalProvider, {
        children
      })
    })
  });
}
export { AnalyticsContext, BricksProvider, defaultAnalyticsContext, useAnalyticsContext };